Ext.define('SA.Scroller', {
    constructor({el, onUserScroll}) {
        this.el = el;
        this.onUserScroll = onUserScroll;

        this.el.addEventListener('scroll', this.onScroll.bind(this));
    },

    constrainScrollPositionToIntrinsicSize({height, width}) {
        this.setTop(Math.min(this.getTop(), height - this.el.clientHeight));
        this.setLeft(Math.min(this.getLeft(), width - this.el.clientWidth));
    },

    getLeft() {
        return this.el.scrollLeft;
    },

    getMaxLeft() {
        return this.el.scrollWidth - this.el.clientWidth;
    },

    getMaxTop() {
        return this.el.scrollHeight - this.el.clientHeight;
    },

    getRect() {
        var top = this.getTop(),
            left = this.getLeft(),
            right = left + this.el.clientWidth,
            bottom = top + this.el.clientHeight;

        return {top, left, right, bottom};
    },

    getScrollability() {
        var top = this.getTop(),
            left = this.getLeft();

        return {
            up: top > 0,
            left: left > 0,
            down: top < this.getMaxTop(),
            right: left < this.getMaxLeft()
        };
    },

    getTop() {
        return this.el.scrollTop;
    },

    on(event, callback, scope) {
        this.el.addEventListener(event, callback.bind(scope));
    },

    onScroll() {
        if (this.ignoreNextScroll) {
            this.ignoreNextScroll = false;
            return;
        }

        this.onUserScroll();
    },

    scrollBy(xDelta, yDelta) {
        this.setTop(this.getTop() + yDelta);
        this.setLeft(this.getLeft() + xDelta);
    },

    setLeft(left) {
        left = Ext.Number.constrain(left, 0, this.getMaxLeft());

        if (this.getLeft() === left) {
            return;
        }

        this.ignoreNextScroll = true;
        this.el.scrollLeft = left;
    },

    setSize(size) {
        Ext.fly(this.el).setSize(size);
    },

    setTop(top) {
        top = Ext.Number.constrain(top, 0, this.getMaxTop());

        if (this.getTop() === top) {
            return;
        }

        this.ignoreNextScroll = true;
        this.el.scrollTop = top;
    }
});